import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { getPropsBlocker } from '../../../utils';
import { paddingAttributes } from '../../../system';
export var DialogActionsRoot = styled.div.withConfig(getPropsBlocker())(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex: 0 0;\n    display: flex;\n    justify-content: flex-end;\n    box-sizing: border-box;\n    flex-shrink: 0;\n    ", "\n    ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.componentOverrides.DialogActions.Root.base;
}, paddingAttributes);